
export default {
    storeInLocalStorage: (value, valueName, objectName) => {
        var store = JSON.parse(localStorage.getItem(objectName));
        if(store === null) {
          store = Object.assign({ [valueName]: value }, store);
        } else {
          if(store[valueName] === undefined) {
            store = Object.assign({ [valueName]: value }, store);
          } else {
            store[valueName] = value;
          }
        }
        localStorage.setItem(objectName, JSON.stringify(store));
    },
    storeObjectInLocalStore: (value, key, valueName, objectName) => {
        var store = JSON.parse(localStorage.getItem(objectName));
        if(store === null) {
          store = Object.assign({ [valueName]: { [key]: value } }, store);
        } else {
          if(store[valueName] === undefined) {
            store = Object.assign({ [valueName]: { [key]: value } }, store);
          } else {
            store[valueName][key] = value;
          }
        }
        localStorage.setItem(objectName, JSON.stringify(store));
    },
    storeArrayInLocalStore: (payload, valueName, objectName) => {
        var store = JSON.parse(localStorage.getItem(objectName));
        if(store === null) {
            store = Object.assign({ [valueName]: [ payload ] }, store);
        } else {
            if(store[valueName] === undefined) {
            store = Object.assign({ [valueName]: [ payload ] }, store);
            } else {
            store[valueName].push(payload);
            }
        }
        localStorage.setItem(objectName, JSON.stringify(store));
    },
    popFromArrayInLocalStore: (valueName, objectName) => {
        var store = JSON.parse(localStorage.getItem(objectName));
        if(store[valueName]) {
            store[valueName].pop();
        }
        localStorage.setItem(objectName, JSON.stringify(store));
    },
    removeFromArrayInLocalStore: (valueName, objectName, index) => {
      var store = JSON.parse(localStorage.getItem(objectName));
      if(store[valueName]) {
        store[valueName].splice(index, 1);
      }
      localStorage.setItem(objectName, JSON.stringify(store));
    },
    storeArrayElementInLocalStore: (value, index, key, valueName, objectName) => {
        var store = JSON.parse(localStorage.getItem(objectName));
        if(store[valueName]) {
            store[valueName][index][key] = value;
        }
        localStorage.setItem(objectName, JSON.stringify(store));
    },
    storeObjectInArrayInLocalStore: (value, index, valueName, objectName) => {
      var store = JSON.parse(localStorage.getItem(objectName));
      if(store[valueName]) {
          store[valueName][index] = value;
      }
      localStorage.setItem(objectName, JSON.stringify(store));
  },
}
